import { render, staticRenderFns } from "./StripList.vue?vue&type=template&id=5003864a&scoped=true&"
import script from "./StripList.vue?vue&type=script&lang=js&"
export * from "./StripList.vue?vue&type=script&lang=js&"
import style0 from "./StripList.vue?vue&type=style&index=0&id=5003864a&lang=scss&scoped=true&"
import style1 from "./StripList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003864a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5003864a')) {
      api.createRecord('5003864a', component.options)
    } else {
      api.reload('5003864a', component.options)
    }
    module.hot.accept("./StripList.vue?vue&type=template&id=5003864a&scoped=true&", function () {
      api.rerender('5003864a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/StripList.vue"
export default component.exports